import styled from '@emotion/styled';
import { Add } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

interface NewButtonProps {
  createdObjectLabel: string;
  bgColor: string;
  color?: string;
  onClick?: () => void;
}

const NewProjectBlock = styled.div<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  flex: none !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid transparent;
  height: 150px;
  width: 200px !important;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  transition: background-color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    border-color: black;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);

    svg {
      transform: scale(1.1);
    }
  }

  svg {
    width: 3rem;
    height: 3rem;
    transition: transform 0.2s ease;
  }
`;

const NewButton = ({
  createdObjectLabel,
  bgColor,
  color = 'black',
  onClick,
}: NewButtonProps) => {
  return (
    <Tooltip title={`Create new ${createdObjectLabel}`} arrow>
      <NewProjectBlock
        onClick={onClick}
        bgColor={bgColor}
        role="button"
        aria-label={`Create new ${createdObjectLabel}`}
      >
        <Add style={{ color }} />
      </NewProjectBlock>
    </Tooltip>
  );
};

export default NewButton;
